module.exports = __webpack_public_path__ + "img/3office4-bg.35380458.jpg";